import { useEffect, useState } from 'react';
import styles from './VimeoEmbed.module.scss';

const VimeoEmbed = ({
  html,
  dimensions,
}: {
  html: string;
  dimensions: {
    height: number;
    width: number;
  };
}) => {
  const [updatedHtml, setUpdatedHtml] = useState(html);

  useEffect(() => {
    let oneTrustActiveGroups;
    if (typeof window !== 'undefined') {
      oneTrustActiveGroups = window.OnetrustActiveGroups;
    }

    const oneTrustPerformanceIsActive = oneTrustActiveGroups?.includes('C0002');

    // If OneTrust Performance is not active, add the dnt=1 query parameter to the Vimeo iframe to enable Do Not Track
    if (!oneTrustPerformanceIsActive) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const iframe = doc.querySelector('iframe');
      if (iframe) {
        const url = new URL(iframe.src);
        url.searchParams.append('dnt', '1');
        iframe.src = url.toString();
        setUpdatedHtml(doc.body.innerHTML);
      }
    }
  }, [html]);

  return (
    <div
      style={{
        paddingBottom: `calc(100% * ${dimensions.height}/${dimensions.width})`,
      }}
      data-testid="data-vimeo-media-embed"
      className={styles.vimeoContainer}
      dangerouslySetInnerHTML={{ __html: updatedHtml }}
    />
  );
};
export default VimeoEmbed;
